module.exports = __webpack_public_path__ + "static/media/ZLWD.53d23ebf.svg";